// extracted by mini-css-extract-plugin
export default {"issueTypePickerButton":"IssueTypePicker-module__issueTypePickerButton--J5MzG","issueTypePickerLabel":"IssueTypePicker-module__issueTypePickerLabel--dutmr"};